import moment from 'moment';
import uniqBy from 'lodash/uniqBy';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import map from 'lodash/map';

import WorkspaceItemCommentsConstants from 'Shared/constants/WorkspaceItemComments.constants';
import MeetingItemsConstants from 'Shared/constants/MeetingItems.constants';
import { getHomePageTasksAfterDrop, mergedSyncList } from 'Shared/reducers/utils';
import { getSourcePage } from 'Shared/utils/getSourcePage';
import { SourcePage } from 'Shared/types/SourcePage.type';
import {
  getMeetingItemsWithAddedNesting,
  getMeetingItemsAfterDrop,
  getMeetingItemsWithRemovedNesting,
  getUpdatedMeetingItem,
} from 'Shared/selectors/meetingItems';

import GoalsConstants from 'Shared/constants/Goals.constants';
import ReviewsConstants from 'Shared/constants/Reviews.constants';

const updatedItemsList = ({ currentList, newList }) =>
  currentList.map(item => newList.find(({ uuid }) => uuid === item.uuid)).filter(item => item);

const intialState = [];

export default function meetingItems(state = intialState, action) {
  switch (action.type) {
    // case 'WORKSPACE_GET_RESPONSE':
    //   return action.payload.meetingItems;
    case 'GET_MEETING_ITEMS_RESPONSE':
      return [...(action.payload.actionItems || []), ...(action.payload.discussionTopics || [])];
    case 'GET_COMPLETED_HOME_PAGE_DATA_RESPONSE':
      return uniqBy([...state, ...action.payload.actionItems, ...action.payload.discussionTopics], 'uuid');
    case 'CLEAR_COMPLETED_HOME_PAGE_DATA':
      return state.filter(({ completed }) => !completed);
    case 'HOME_PAGE_TASK_ASSIGNED_DROP_REQUEST':
      return getHomePageTasksAfterDrop(state, action.payload);
    case 'CLEAR_MEETING_ITEMS':
      return intialState;
    case 'TOGGLE_ITEM_TYPE': {
      return state.map(meetingItem => {
        if (action.payload.uuid === meetingItem.uuid) {
          return { ...meetingItem, itemType: action.payload.newItemType, dueBy: action.payload.dueBy };
        }
        return meetingItem;
      });
    }
    case GoalsConstants.Actions.UPDATE_ACTION_ITEM_ORDER_PREREQUEST:
      return getMeetingItemsAfterDrop(state, action.payload);
    case 'ADD_MEETING_ITEM_ATTACHMENT_RESPONSE':
      return state.map(meetingItem => {
        if (meetingItem.uuid === action.payload.uuid) {
          return { ...meetingItem, attachments: uniqBy([...meetingItem.attachments, action.payload.attachment], 'id') };
        }
        if (meetingItem.uuid === action.payload.parentUuid)
          return { ...meetingItem, updatedAt: action.payload.parentUpdatedAt };
        return meetingItem;
      });
    case 'MEETING_ITEM_UPDATE_REQUEST':
    case 'UPDATE_MEETING_ITEM_RESPONSE':
      return getUpdatedMeetingItem(state, action.payload);
    case 'MEETING_ITEM_UPDATE_ERROR':
      return state.map(item => (item.uuid === action.payload.uuid ? action.payload : item));
    case 'CREATE_WORKSPACE_COMMENT_REQUEST':
    case 'DESTROY_WORKSPACE_COMMENT_ERROR':
      return state.map(meetingItem => {
        if (meetingItem.id === action.payload.meetingItem.id) {
          return { ...meetingItem, comments: [...meetingItem.comments, action.payload.workspaceComment] };
        }

        return meetingItem;
      });
    case 'CREATE_WORKSPACE_COMMENT_RESPONSE':
      return state.map(meetingItem => {
        if (meetingItem.id === action.payload.meetingItem.parentId) {
          return { ...meetingItem, updatedAt: action.payload.workspaceComment.meetingItemUpdatedAt };
        }
        if (meetingItem.id === action.payload.meetingItem.id) {
          return {
            ...meetingItem,
            commentsCount: meetingItem.commentsCount + 1,
          };
        }
        return meetingItem;
      });
    case 'UPDATE_COMMENT_ITEM_RESPONSE':
      return state.map(meetingItem => {
        if (meetingItem.id === action.payload.meetingItem.parentId) {
          return { ...meetingItem, updatedAt: action.payload.workspaceComment.meetingItemUpdatedAt };
        }
        if (meetingItem.id === action.payload.meetingItem.id) {
          return {
            ...meetingItem,
            comments: meetingItem.comments.map(comment => {
              if (comment.uuid === action.payload.workspaceComment.uuid) return action.payload.workspaceComment;
              return comment;
            }),
          };
        }
        return meetingItem;
      });
    case 'CREATE_WORKSPACE_COMMENT_ERROR':
    case 'DESTROY_WORKSPACE_COMMENT_REQUEST':
      return state.map(meetingItem => {
        if (meetingItem.id === action.payload.meetingItem.id) {
          return {
            ...meetingItem,
            comments: meetingItem.comments.filter(comment => comment.uuid !== action.payload.workspaceComment.uuid),
            commentsCount: meetingItem.commentsCount - 1,
          };
        }

        return meetingItem;
      });
    case 'REMOVE_COMMENT_ATTACHMENT_RESPONSE':
      return state.map(meetingItem => {
        if (meetingItem.id === action.payload.meetingItem.id) {
          return {
            ...meetingItem,
            comments: meetingItem.comments.map(comment => {
              if (comment.uuid === action.payload.commentUuid) {
                return {
                  ...comment,
                  attachments: comment.attachments.filter(attachment => attachment.id !== action.payload.attachmentId),
                };
              }

              return comment;
            }),
          };
        }
        return meetingItem;
      });
    case 'MEETING_ITEM_REMOVE_ATTACHMENT_RESPONSE':
      return state.map(meetingItem => {
        if (meetingItem.uuid === action.payload.uuid) {
          return {
            ...meetingItem,
            attachments: meetingItem.attachments.filter(attachment => attachment.id !== action.payload.attachmentId),
          };
        }
        return meetingItem;
      });
    case 'BULK_UPDATE_MEETING_ITEM_RESPONSE':
      return state.map(meetingItem => {
        const newMeetingItem = action.payload.find(({ uuid }) => uuid === meetingItem.uuid);
        if (newMeetingItem) return newMeetingItem;
        return meetingItem;
      });
    case 'MEETING_ITEM_REMOVE_REQUEST':
      return state
        .filter(({ uuid }) => uuid !== action.payload.uuid)
        .map((item, index) => ({ ...item, position: index + 1 }));
    case 'MEETING_ITEM_REMOVE_ERROR':
      return [...state, action.payload.item];
    case 'MEETING_ITEM_NEST_REQUEST':
      return getMeetingItemsWithAddedNesting(state, action.payload);
    case 'MEETING_ITEM_SET_COMPLETED_REQUEST':
    case 'MEETING_ITEM_SET_COMPLETED_ERROR':
      return state.map(todo => {
        if (todo.uuid === action.payload.uuid) {
          return {
            ...todo,
            completed: action.payload.completed,
            completedAt: action.payload.completed ? moment().unix() : null,
            completedBy: action.payload.completedBy,
          };
        }
        return todo;
      });
    case 'MEETING_ITEM_SET_COMPLETED_RESPONSE':
      return state.map(item => {
        const updatedItem = action.payload.find(toggledItem => toggledItem.uuid === item.uuid);
        return updatedItem
          ? {
              ...item,
              completed: updatedItem.completed,
              completedAt: updatedItem.completedAt,
              completedBy: updatedItem.completedBy,
            }
          : item;
      });
    case 'MEETING_ITEM_REMOVE_NESTING_REQUEST':
      return getMeetingItemsWithRemovedNesting(state, action.payload);
    case 'MEETING_ITEM_ADD_RESPONSE':
      return state.map(item => {
        if (item.uuid === action.payload.uuid)
          return {
            ...action.payload,
            isShowLoader: false,
            body: item.body,
            parentId: item.parentId,
            parentUuid: item.parentUuid,
          };
        return item;
      });
    case 'MEETING_ITEM_ADD_REQUEST': {
      if (getSourcePage() === SourcePage.workspace) return state;

      const positionField = action.positionField;
      const insertIndex = state.map(i => i[positionField]).indexOf(action.payload[positionField] - 1);

      state.splice(insertIndex + 1, 0, action.payload);
      return state.map((item, index) => ({
        ...item,
        [positionField]: index + 1,
      }));
    }
    case 'MEETING_ITEM_ADD_ERROR':
      return state.filter(({ uuid }) => uuid !== action.payload.uuid);
    case 'MEETING_ITEM_WITH_CHILD_ADD_REQUEST':
      return [...action.payload, ...state].map((item, index) => ({
        ...item,
        position: index + 1,
      }));
    case 'MEETING_ITEM_WITH_CHILD_ADD_RESPONSE':
      return state.map(item => {
        const newItem = action.payload.find(({ uuid }) => item.uuid === uuid);
        if (newItem) return newItem;
        return item;
      });
    case 'MEETING_ITEM_WITH_CHILD_ADD_ERROR':
      return state.filter(item => !action.payload.find(({ uuid }) => item.uuid === uuid));
    case 'MEETING_ITEM_BULK_ADD_REQUEST': {
      const { currentUuid, items } = action.payload;
      if (currentUuid) {
        const index = state.findIndex(i => i.uuid === currentUuid);
        return [...state.slice(0, index + 1), ...items, ...state.slice(index + 1)];
      }
      return [...items, ...state];
    }
    case 'MEETING_ITEM_BULK_ADD_RESPONSE':
      return state.map(item => {
        const newItem = action.payload.find(i => i.uuid === item.uuid);
        if (newItem) {
          return newItem;
        }
        return item;
      });
    case 'MEETING_ITEM_BULK_ADD_ERROR':
      return state.filter(item => !action.payload.uuids.includes(item.uuid));
    case 'UPDATE_MEETING_ITEM_RECURRENCE':
    case 'REMOVE_MEETING_ITEM_RECURRENCE':
      return state.map(todo => {
        if (todo.uuid === action.payload.uuid || (!action.payload.isEdit && todo.parentUuid === action.payload.uuid)) {
          return {
            ...todo,
            recurringWorkspaceItem: action.payload.recurringWorkspaceItem,
          };
        }
        return todo;
      });
    case 'MEETING_ITEM_BULK_UPDATE_REQUEST':
      return state.map(meetingItem => {
        if (action.payload.selectedUuids.includes(meetingItem.uuid))
          return { ...meetingItem, ...action.payload.params };
        return meetingItem;
      });
    case 'MEETING_ITEM_BULK_REMOVE_REQUEST':
      return state
        .filter(({ uuid }) => !action.payload.selectedUuids.includes(uuid))
        .map((item, index) => ({ ...item, position: index + 1 }));
    case 'DUPLICATE_ACROSS_WORKSPACES_RESPONSE':
      return action.payload.isMoveItems
        ? [...state.filter(({ uuid }) => !action.payload.itemUuids.includes(uuid)), ...action.payload.data]
        : [...state, ...action.payload.data];
    case 'CLEAR_COMPLETED_ITEMS': {
      const startOfWeek = moment().startOf('week').unix();
      return state.filter(({ completedAt, completed }) => !completed || completedAt > startOfWeek);
    }
    case 'MEETING_ITEMS_SYNC':
      return mergedSyncList({
        currentList: state,
        newList: [...(action.meetingItems || []), ...(action.discussionTopics || [])],
        deletedList: [...(action.deletedMeetingItems || []), ...(action.deletedDiscussionTopics || [])],
      });
    case 'WORKSPACE_UPDATES_GET_RESPONSE':
      return updatedItemsList({
        currentList: state,
        newList: [...(action.payload.meeting_items || []), ...(action.payload.discussion_topics || [])],
      });
    case ReviewsConstants.Actions.FETCH_SINGLE_REVIEW_SUCCESS:
    case GoalsConstants.Actions.FETCH_SINGLE_GOAL_SUCCESS:
      if (isEmpty(action.payload.workspaceItem)) return state;
      return uniqBy(
        [...state, ...Object.values(action.payload.workspaceItem).map(({ attributes }) => attributes)],
        'uuid'
      );
    case GoalsConstants.Actions.MARK_GOAL_COMPLETE_AND_ACTION_ITEMS_COMPLETE_SUCCESS:
      return state.map(item => (item.goalSlug === action.payload.goalSlug ? { ...item, completed: true } : item));

    // This is needed hopefully temporarily to allow updates from the new MeetingItem.Actions to flow
    // into the older state object to render udpates
    case WorkspaceItemCommentsConstants.Actions.CREATE_WORKSPACE_ITEM_COMMENT_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_HIGH_PRIORITY_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_COMPLETE_STATUS_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_DUE_BY_SUCCESS:
    case MeetingItemsConstants.Actions.ATTACH_FILE_SUCCESS:
    case MeetingItemsConstants.Actions.DELETE_FILE_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_SHOW_PREVIEW_SUCCESS:
    case MeetingItemsConstants.Actions.DELETE_RECURRENCE_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_RECURRENCE_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_ASSIGNEE_SUCCESS:
    case MeetingItemsConstants.Actions.CREATE_ASANA_TASK_SUCCESS:
    case MeetingItemsConstants.Actions.DISCONNECT_ASANA_TASK_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_ITEM_BODY_SUCCESS:
    case MeetingItemsConstants.Actions.CREATE_NEW_MEETING_ITEM_SUCCESS:
    case MeetingItemsConstants.Actions.REMOVE_NESTING_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_PARENT_UUID_SUCCESS:
    case MeetingItemsConstants.Actions.ADD_TO_GOAL_SUCCESS:
    case MeetingItemsConstants.Actions.REMOVE_FROM_GOAL_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_ASSIGNE_SUCCESS:
    case MeetingItemsConstants.Actions.DUPLICATE_ITEM:
      return map(state, item => {
        return merge(
          item,
          Object.values(action.payload.meetingItem)
            .map(val => {
              return val.attributes;
            })
            .find(updatedItem => updatedItem.uuid === item.uuid)
        );
      });

    case MeetingItemsConstants.Actions.FETCH_MEETING_ITEMS_SUCCESS:
    case MeetingItemsConstants.Actions.FETCH_SINGLE_MEETING_ITEMS_SUCCESS:
      return uniqBy(
        [
          ...state,
          Object.values(action.payload.meetingItem).map(val => {
            return val.attributes;
          }),
        ],
        'uuid'
      );

    case MeetingItemsConstants.Actions.DELETE_MEETING_ITEM_SUCCESS:
      console.log(action.payload);
      return state.filter(item => item.uuid !== action.payload.meetingItemSlug);
    // End updates from new actions dispatcher
    default:
      return state;
  }
}
